import { useState } from "react";
import { useLocation } from "react-router-dom";
import RlHeaderLogo from "./RlHeaderLogo";
import RlNavigation from "./navigation/RlNavigation";
import GlobalUpload from "./GlobalUpload";
import GlobalSearch from "./search/GlobalSearch";
import useToggleClass from "../../hooks/useToggleClass";
import { PAGE_PATH } from "../../path";
import LicenseValidChecker from "../licensing/containers/LicenseValidChecker";
import LicenseWarning from "../licensing/containers/LicensingWarning";

type RlHeaderProps = {
  productName: string;
  user: {
    name: string;
    isAdmin: boolean;
  };
  linksReloadDocument?: boolean;
};

const RlHeader = ({
  productName = "Spectra Analyze Malware Analysis Platform™",
  user,
  linksReloadDocument = true
}: RlHeaderProps) => {
  const [searchBarExpanded, setSearchBarExpanded] = useState(false);
  const { pathname } = useLocation();
  const showGlobalSearch = pathname !== PAGE_PATH.SEARCH;

  useToggleClass(
    "app-header",
    searchBarExpanded,
    "app-header--search-bar-expanded"
  );

  return (
    <header id="app-header" className="app-header layout rlbs">
      <div className="app-header__content-left">
        <RlHeaderLogo
          productName={productName}
          linksReloadDocument={linksReloadDocument}
        />
        <LicenseWarning />
        <LicenseValidChecker>
          {showGlobalSearch && (
            <div className="app-header__search-container">
              <GlobalSearch
                key={pathname}
                setSearchBarExpanded={setSearchBarExpanded}
                linksReloadDocument={linksReloadDocument}
              />
            </div>
          )}
        </LicenseValidChecker>
      </div>
      <div className="app-header__content-right">
        <LicenseValidChecker>
          <GlobalUpload linksReloadDocument={linksReloadDocument} />
        </LicenseValidChecker>
        <RlNavigation
          user={user}
          linksReloadDocumentOverride={linksReloadDocument}
        />
      </div>
    </header>
  );
};

export default RlHeader;
